import {Injectable} from '@angular/core';
import {getSupportedLanguage, UiUtils} from "../../shared/utils/ui.utils";
import {Product} from "../models/product";

@Injectable({
  providedIn: 'root'
})
export class QueryParamBootstrapperService {

  private readonly PARAMS = ["license", "licenseCountryCode", "externalId", "lang", "beta", "mileage", "phone", "email", "postcode", "embedded", "context", "redirectionURL"];

  readParams(): QueryParamData {
    const params = this.extractParams();

    return {
      license: params['license']?.toUpperCase(),
      licenseCountryCode: params['licenseCountryCode'],
      externalId: params['externalId'],
      lang: UiUtils.formatLocale(getSupportedLanguage(params["lang"])),
      beta: params['beta'] === 'true',
      mileage: params['mileage'] && !isNaN(+params['mileage']) ? +params['mileage'] : undefined,
      phone: params['phone'],
      email: params['email'],
      postcode: params['postcode'],
      embedded: params['embedded'] === 'true',
      redirectionURL: params['redirectionURL'],
      urlContext: params['context'],
      product: this.getProductFromUrl()
    };
  }

  private getProductFromUrl(): Product {
    const hash = window.location.hash || '';
    const path = hash.replace(/^#\//, '').split('?')[0];

    if (path.startsWith('scanner')) return Product.SCANNER;
    if (path.startsWith('collect')) return Product.COLLECT;
    if (path.startsWith('diagnosis')) return Product.DIAGNOSIS;
    if (path.startsWith('report')) return Product.REPORT;
    if (path.startsWith('appointment')) return Product.APPOINTMENT;

    return Product.UNKNOWN;
  }

  private extractParams(): Record<string, string> {
    const hash = window.location.hash;
    const [path, qs] = hash.split("?");
    if (!qs) return {};
    const searchParams = new URLSearchParams(qs);
    const out: Record<string, string> = {};
    for (const key of this.PARAMS) {
      const val = searchParams.get(key);
      if (val !== null) out[key] = decodeURIComponent(val);
    }
    return out;
  }
}

export interface QueryParamData {
  license?: string;
  licenseCountryCode?: string;
  externalId?: string;
  lang?: string;
  beta?: boolean;
  mileage?: number;
  phone?: string;
  email?: string;
  postcode?: string;
  embedded?: boolean;
  redirectionURL?: string;
  urlContext?: string;
  product: Product;
}
